import { useAppSelector } from "../../hooks";
import { AppRoutes } from "../../../routes/app-routes";

const menuItems = Object.values(AppRoutes).filter((r) => r.isNavItem);

export const useAppState = () => {
	const useAppRoutes = () => AppRoutes;
	const useMenuItems = () => menuItems;
	const useApiError = () => useAppSelector((state) => state.app.apiError);
	const useDarkMode = () => useAppSelector((state) => state.app.darkMode);
	const useHideMascot = () => useAppSelector((state) => state.app.hideMascot);

	const state = {
		appRoutes: useAppRoutes,
		menuItems: useMenuItems,
		apiError: useApiError,
		darkMode: useDarkMode,
		hideMascot: useHideMascot
	};

	return {
		state
	};
};
